// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","201":"069e5f659d2533a9caa4","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"0a3388b93e35ee3874d0","765":"85e2cb3a12e4732aa483","852":"bbc102af75528f1ede33"}[chunkId] + ".bundle.js";
};